import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";
import "./index.scss";
import AdminLoader from "./components/AdminLoader";

// Backend category/product allowlist for this storefront (must match STOREFRONT_CATEGORY_ALLOWLISTS key)
const storefrontSlug = process.env.REACT_APP_STOREFRONT_SLUG;
if (storefrontSlug && String(storefrontSlug).trim()) {
  axios.defaults.headers.common["X-Storefront"] = String(storefrontSlug)
    .trim()
    .toLowerCase();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AdminLoader />
    <App />
  </Provider>,
);
